(function () {
  'use strict';

  angular.module('app').component('transportationContentsPage', transportationContentListCtrl());

  function transportationContentListCtrl() {
    return {
      bindings: {},
      controller: TransportationContentListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/transportation-contents/transportation-contents-page.component.html',
    };
  }

  TransportationContentListCtrl.$inject = [
    '$location',
    'UtilService',
    'AbilityService',
    'SessionService',
    '$routeParams',
    'TransportationService',
    'TransportationContentService',
    'LanguageService',

    // Angular downgraded service
    'ng2Router',
  ];

  function TransportationContentListCtrl(
    $location,
    UtilService,
    AbilityService,
    SessionService,
    $routeParams,
    TransportationService,
    TransportationContentService,
    LanguageService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var companyWebsites = SessionService.getSelectedAccountCompany().websites;

    if (companyWebsites.length === 0) {
      vm.errorWebsites = true;
    }

    vm.permissions = {
      canCreate: AbilityService.can('create_transportation_accountadmin'),
    };

    vm.websiteId = $routeParams.WSID;
    vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
    vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

    // Methods
    vm.addTransportationContent = addTransportationContent;
    vm.onTransportationContentShowed = onTransportationContentShowed;

    vm.openTransportationListModal = openTransportationListModal;

    // Initializers
    getDefaultLanguage();
    // getTransportationsContents();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getTransportationsContents();
      });
    }

    function getTransportationsContents() {
      vm.filterCriteria = TransportationContentService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      TransportationContentService.getTransportationsContents(vm.websiteId, vm.filterCriteria).then(
        function (data) {
          vm.items = data.items;
          vm.meta = data.meta;

          vm.totalItems = vm.meta.totalItems;

          vm.loadingItems = false;
        }
      );
    }

    function addTransportationContent() {
      $location.path(`/transportation_contents/new`).search({ WSID: vm.websiteId });
    }

    function onTransportationContentShowed(item, mode) {
      $location
        .path(`/transportation_contents/${item.id}`)
        .search({ WSID: vm.websiteId, mode: mode });
    }

    function openTransportationListModal() {
      var transportationIds = [];

      vm.items.forEach(function (content) {
        transportationIds.push(content.transportation_id);
      });

      TransportationService.openTransportationListModal(transportationIds, vm.websiteId);
    }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };

    vm.goToWebsiteNew = () => {
      ng2Router.navigate(['/ng/websites/new']);
    };
  }
})();
